<template id="event-stream">
  <div style="height: 0px"></div>
</template>

<script>
import appSettings from "./appSettings";
import { mapState } from "vuex";

export default {
  name: "EventStream",
  data: () => ({
    isReconnecting: false,
    isCreated: false,
    pingEvent: null,
  }),
  computed: {
    ...mapState(["idToken", "tokenExpiry"]),
  },
  watch: {
    idToken() {
      if (!this.isCreated) return;
      this.clearPingInterval();
      this.connectToWebsocket();
    },
  },
  created() {
    this.connectToWebsocket();
    this.isCreated = true;
  },
  deleted() {
    this.clearPingInterval();
    if (this.websocket) {
      this.websocket.close();
    }
  },
  methods: {
    onEvent(e) {
      if (e.data == "pong") return; // Keep alive
      this.$emit("eventgrid-event", JSON.parse(e.data));
    },
    isValidToken() {
      return this.idToken && this.tokenExpiry * 1000 > Date.now();
    },
    connectToWebsocket() {
      if (!this.isValidToken()) return;

      this.websocket = new WebSocket(
        `${appSettings.remotewsurl}/api/event?access_token=${
          this.idToken
        }&session_id=${window.localStorage["sessionId"] ?? ""}`
      );
      this.websocket.onmessage = this.onEvent;
      this.websocket.onclose = this.onClose;
      this.websocket.onerror = this.onError;
      this.websocket.onopen = this.onOpen;
    },
    onOpen() {
      const websocket = this.websocket;
      this.pingEvent = setInterval(function () {
        websocket.send("ping");
      }, 5000);
    },
    onClose(event) {
      this.isReconnecting = false;
      this.$appInsights.trackEvent({
        name: "socket-closed",
        properties: {
          code: event.code,
          reason: event.reason,
        },
      });
      this.attemptReconnect();
    },
    onError() {
      // On error provides little information so just provide a generic message to app insights
      this.$appInsights.trackException({
        exception: new Error("Socket closed with error"),
      });
      this.attemptReconnect();
    },
    clearPingInterval() {
      if (this.pingEvent) {
        clearInterval(this.pingEvent);
        this.pingEvent = null;
      }
    },
    attemptReconnect() {
      if (this.isReconnecting || !this.isCreated) return;

      this.clearPingInterval();
      this.isReconnecting = true;
      this.connectToWebsocket();
    },
  },
};
</script>
